import React from 'react'
import Checkbox from 'app/theme/forms/Checkbox'

export default function ListingVehicleTypeFilter({ vehicleType, setVehicleType }) {
  return (
    <div className="my-6 md:my-0">
      <h3 className="text-md text-black font-bold mb-4">Vehicle Types</h3>
      <div className="w-full">
        <div className="w-full py-2">
          <Checkbox
            label="Food Truck"
            checked={vehicleType ? vehicleType.indexOf("truck") >= 0 : false}
            onChange={checked => (
              setVehicleType(checked, 'truck')
            )}
          />
        </div>
        <div className="w-full py-2">
          <Checkbox
            label="Trailer"
            checked={vehicleType ? vehicleType.indexOf("trailer") >= 0 : false}
            onChange={checked => {
              setVehicleType(checked, 'trailer')
            }}
          />
        </div>
        <div className="w-full py-2">
          <Checkbox
            label="Cart"
            checked={vehicleType ? vehicleType.indexOf("cart") >= 0 : false}
            onChange={checked => {
              setVehicleType(checked, 'cart')
            }}
          />
        </div>
      </div>
    </div>
  )
}
